<app-dialog-heading [heading]="'Edit Person Name'"></app-dialog-heading>

<div class="dialog-content">
  <form [formGroup]="fullNameFormGroup">

    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input required [formControl]="firstNameFormControl" type="text" matInput>
    </mat-form-field>

    <br>

    <mat-form-field>
      <mat-label>Middle Name</mat-label>
      <input [formControl]="middleNameFormControl" type="text" matInput>
    </mat-form-field>

    <br>

    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input required [formControl]="lastNameFormControl" type="text" matInput>
    </mat-form-field>

  </form>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
  <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn">Cancel</button>
</mat-dialog-actions>
